(function () {
  "use strict";
  if (window.__pbxSuggest) return;
  window.__pbxSuggest = true;

  var input = document.getElementById("pbx-search-input");
  if (!input) return;
  var form = input.closest("form");
  var btn = document.getElementById("pbx-search-btn");
  var box = document.createElement("div");
  box.className = "pbx-suggest";
  box.hidden = true;
  box.id = "pbx-suggest";
  document.body.appendChild(box);
  input.setAttribute("aria-controls", "pbx-suggest");
  input.setAttribute("autocomplete", "off");

  var timer, ctl, lastQ = "";

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
  function money(v) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "PLN";
    var n = parseFloat(v);
    if (isNaN(n)) return "";
    try { return new Intl.NumberFormat(document.documentElement.lang || "pl-PL", { style: "currency", currency: cur }).format(n); }
    catch (e) { return n.toFixed(2) + " " + cur; }
  }
  function position() {
    var nav = document.getElementById("pbx-nav");
    box.style.top = (nav ? Math.round(nav.getBoundingClientRect().bottom) : 106) + "px";
  }
  function hide() { box.hidden = true; box.innerHTML = ""; input.removeAttribute("aria-expanded"); }
  function brandOf(p) {
    var t = (p.tags || []).filter(function (x) { return String(x).indexOf("rodzina:") !== 0; })[0];
    return t || p.vendor || "";
  }
  function cleanTitle(t) { return String(t).replace(" - Odlewka Perfum", ""); }

  function render(q, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var prods = res.products || [];
    var queries = res.queries || [];
    var html = '<div class="pbx-suggest-inner">';
    if (queries.length) {
      html += '<p class="pbx-sg-label">Podpowiedzi</p><div class="pbx-sg-queries">';
      queries.slice(0, 5).forEach(function (s) {
        html += '<a class="pbx-sg-query" href="' + esc(s.url) + '">' + esc(s.text) + "</a>";
      });
      html += "</div>";
    }
    if (prods.length) {
      html += '<p class="pbx-sg-label">Zapachy</p>';
      prods.forEach(function (p) {
        var img = p.image ? p.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "";
        html += '<a class="pbx-sg-item" href="' + esc(p.url) + '" role="option">' +
          '<span class="pbx-sg-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : "") + "</span>" +
          '<span><span class="pbx-sg-brand">' + esc(brandOf(p)) + '</span><span class="pbx-sg-name">' + esc(cleanTitle(p.title)) + "</span></span>" +
          '<span class="pbx-sg-price">' + esc(money(p.price)) + "</span></a>";
      });
    }
    if (!prods.length && !queries.length) {
      html += '<p class="pbx-sg-empty">Brak dokładnych wyników dla „' + esc(q) + '”. Spróbuj innej nazwy lub zobacz wszystkie wyniki.</p>';
    }
    html += '<a class="pbx-sg-all" href="/search?q=' + encodeURIComponent(q) + '"><span>Zobacz wszystkie wyniki dla „' + esc(q) + '”</span><span aria-hidden="true">→</span></a>';
    html += "</div>";
    box.innerHTML = html;
    position();
    box.hidden = false;
    input.setAttribute("aria-expanded", "true");
  }

  function query(q) {
    if (ctl) ctl.abort();
    ctl = ("AbortController" in window) ? new AbortController() : null;
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product,query&resources[limit]=6&resources[limit_scope]=each" +
      "&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title";
    fetch(url, { signal: ctl ? ctl.signal : undefined, headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("bad"); return r.json(); })
      .then(function (d) { if (input.value.trim() === q) render(q, d); })
      .catch(function (e) { if (e && e.name === "AbortError") return; });
  }

  input.addEventListener("input", function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { hide(); lastQ = ""; return; }
    if (q === lastQ) return;
    lastQ = q;
    timer = setTimeout(function () { query(q); }, 160);
  });
  input.addEventListener("focus", function () { if (input.value.trim().length >= 2 && box.innerHTML) { position(); box.hidden = false; } });
  input.addEventListener("keydown", function (e) {
    if (e.key === "ArrowDown") {
      var first = box.querySelector(".pbx-sg-item, .pbx-sg-query");
      if (first) { e.preventDefault(); first.focus(); }
    } else if (e.key === "Escape") { hide(); }
  });
  box.addEventListener("keydown", function (e) {
    var items = Array.prototype.slice.call(box.querySelectorAll("a"));
    var i = items.indexOf(document.activeElement);
    if (e.key === "ArrowDown" && i < items.length - 1) { e.preventDefault(); items[i + 1].focus(); }
    else if (e.key === "ArrowUp") { e.preventDefault(); if (i > 0) items[i - 1].focus(); else input.focus(); }
    else if (e.key === "Escape") { hide(); input.focus(); }
  });
  document.addEventListener("click", function (e) {
    if (box.hidden) return;
    if (box.contains(e.target) || e.target === input || (btn && btn.contains(e.target))) return;
    hide();
  });
  window.addEventListener("scroll", function () { if (!box.hidden) position(); }, { passive: true });
  window.addEventListener("resize", function () { if (!box.hidden) position(); });
  if (form) form.addEventListener("submit", function () { hide(); });
})();
